import { render, staticRenderFns } from "./sumberpenerangan.vue?vue&type=template&id=17ae9770"
import script from "./sumberpenerangan.vue?vue&type=script&lang=js"
export * from "./sumberpenerangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports